module.exports = {
	Nothing: 0,
	StartBuildMainMachine: 1,
	StartBuildPlayer: 2,
	Unknown: 99
}